import { useState } from "react";
import { Newspaper, Play } from "lucide-react";
import { MEDIA_ITEMS } from "@/lib/site";
import { Reveal, SectionHead } from "./shared";

const VideoCard = ({ item }) => {
  const [playing, setPlaying] = useState(false);
  return (
    <div
      className="overflow-hidden rounded-xl border border-gold/25 bg-lake-teal/30 transition-colors duration-300 hover:border-gold/50"
      data-testid={`media-card-${item.id}`}
    >
      {playing ? (
        <div className="aspect-video w-full">
          <iframe
            src={`https://www.youtube.com/embed/${item.youtubeId}?autoplay=1&rel=0`}
            title={item.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="h-full w-full"
          />
        </div>
      ) : (
        <button
          data-testid={`media-play-${item.id}`}
          onClick={() => setPlaying(true)}
          className="group relative block aspect-video w-full"
        >
          <img
            src={`https://i.ytimg.com/vi/${item.youtubeId}/hqdefault.jpg`}
            alt={item.title}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <span className="absolute inset-0 bg-lake-deep/30 transition-colors duration-300 group-hover:bg-lake-deep/10" />
          <span className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-gold-shimmer/80 bg-lake-deep/70 backdrop-blur-sm transition-transform duration-300 group-hover:scale-110">
            <Play className="h-6 w-6 translate-x-0.5 text-gold-shimmer" fill="currentColor" />
          </span>
          <span className="absolute left-3 top-3 rounded-full bg-lake-deep/85 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-gold-shimmer">
            Video
          </span>
        </button>
      )}
      <div className="p-6">
        <h3 className="font-serif text-lg leading-snug text-parchment-ivory">{item.title}</h3>
        <p className="mt-1.5 text-xs uppercase tracking-[0.2em] text-gold">{item.source}</p>
        <p className="mt-3 text-sm leading-relaxed text-parchment-ivory/60">{item.note}</p>
      </div>
    </div>
  );
};

const ArticleCard = ({ item }) => (
  <a
    href={item.url}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`media-card-${item.id}`}
    className="flex h-full flex-col rounded-xl border border-gold/25 bg-lake-teal/30 p-6 transition-colors duration-300 hover:border-gold/50"
  >
    <span className="inline-flex w-fit items-center gap-2 rounded-full bg-lake-deep/85 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-gold-shimmer">
      <Newspaper className="h-3 w-3" />
      Articolo
    </span>
    <h3 className="mt-4 font-serif text-lg leading-snug text-parchment-ivory">{item.title}</h3>
    <p className="mt-1.5 text-xs uppercase tracking-[0.2em] text-gold">{item.source}</p>
    <p className="mt-3 flex-1 text-sm leading-relaxed text-parchment-ivory/60">{item.note}</p>
    <span className="mt-4 text-xs font-semibold text-gold-shimmer">Leggi l'articolo →</span>
  </a>
);

export default function Media() {
  return (
    <section id="media" className="relative bg-lake-teal/20 py-20 lg:py-32" data-testid="media-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          kicker="Rassegna Stampa & Media"
          title="Dicono del libro"
          sub="Articoli, video e voci che raccontano Il Segreto del Lago e il suo legame con il territorio."
        />
        <div className="mx-auto mt-14 grid max-w-5xl grid-cols-1 gap-6 sm:grid-cols-2">
          {MEDIA_ITEMS.map((item, i) => (
            <Reveal key={item.id} delay={i * 0.1}>
              {item.type === "video" ? <VideoCard item={item} /> : <ArticleCard item={item} />}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
